<template>
	<div :class="classes">
		<!-- User details -->
		<p v-if="!leftAlign" class="user__name user__name--left">{{ email }}</p>
		<div class="user__icon">
			<IconAccount :class="{ invert }" />
		</div>
		<p v-if="leftAlign" class="user__name user__name--right">{{ email }}</p>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import IconAccount from 'mdi-vue/Account'

export default {
	name: 'User',
	props: {
		align: {
			type: String,
			default: 'left',
			validator: v => ['left', 'right'].includes(v),
		},
		invert: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		...mapGetters({ email: 'auth/email' }),
		leftAlign() {
			return this.align === 'left'
		},
		classes() {
			return ['user', { 'user--invert': this.invert }]
		},
	},
	components: {
		IconAccount,
	},
}
</script>

<style lang="scss" scoped>
@import '~scss/vars';
@import '~scss/layout';
@import '~scss/components';

.user {
	@extend %flex-center;
	position: relative;

	&__icon {
		@include square(1.875rem);
	}

	&__name {
		&--left {
			margin-right: 0.5rem;
		}
		&--right {
			margin-left: 0.5rem;
		}
	}

	&--invert {
		color: $white;
	}
}
</style>
